import React, { useContext, useEffect, useState } from 'react'
import ImagesItem from './ImagesItem'
import Loading from '../../components/Loading'
import CustomModal from '../../components/Modal/CustomModal'
import { store } from '../../components/HOC/State'
import { translate } from '../translate'
import { axiosInstance } from '../../const/axiosInstance'
import { BACKEND_URL } from '../../const/Constant'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import styles from './imagesLibrary.module.css'
import cntrStyles from '../Expo/expo.module.css'

export default function ImagesLibrary() {
  const [arr, setArr] = useState([])
  const [loading, setLoading] = useState(false)
  const [updateed, setUpdated] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const {offset, setOffset, setOffsetUpdated,selectedLang} = useContext(store)
  const limit = 20

  let lang = translate[selectedLang]

  useEffect(() => {
    setOffset(0)
    setUpdated(true)
  }, [])

  const close = () => {
    setShowModal(false)
}


  useEffect(() =>{
    (async() => {
      if(updateed){
        setLoading(true)
        const res = await axiosInstance.get(`/use/library?offset=${offset}&limit=${limit}`)
        if(res.data.status){
          setArr([...arr,...res.data.data])
          if(res.data.data.length == 20){
            setOffsetUpdated(false)
          }
        }else{
          setArr([...arr])
        }
        setLoading(false)
      }
    })()
  }, [offset, updateed])

  const slideLeft = () => {
    if(currentIndex){
      setCurrentIndex(p => p - 1)
    }else{
      setCurrentIndex(arr.length - 1)
    }
  }

  const slideRight = () => {
    if(currentIndex != arr.length - 1){
      setCurrentIndex(p => p + 1)
    }else{
      setCurrentIndex(0)
    }
  }

  return (
    <div className={styles['images-library-main']}>
        <div className={styles['images-library-div']}>
            <p className={styles['images-library-category']}>{lang.tr_galery}</p>
            <div >
              {arr.length ? 
                <div className={styles['images-div']}>
                  {arr.map((el, i) => <ImagesItem key={el._id} el={el} setShowModal={setShowModal} index={i} setCurrentIndex={setCurrentIndex}/>)}
                  {loading ? <Loading width={200}/> : ""}
                </div>
                :
                !loading ? <p className='empty-message'>{lang.tr_noPublished}</p> : null
              }

          {showModal && 
                <CustomModal close={close}>
                      <img src={BACKEND_URL + arr[currentIndex].image} alt='mergelyan-image'/>
                      <div className={cntrStyles['control-div']}>
                        <div onClick={slideLeft} className={`${cntrStyles['left']} ${cntrStyles['control-btn']}`}>
                            <FontAwesomeIcon className={cntrStyles['control-icon']} icon={faAngleLeft} />
                        </div>
                        <div onClick={slideRight} className={`${cntrStyles['right']} ${cntrStyles['control-btn']}`}>
                            <FontAwesomeIcon className={cntrStyles['control-icon']} icon={faAngleRight} />
                        </div>
                    </div>
                </CustomModal>}

              
            </div>
        </div>
    </div>
  )
}
